import {IPortalseite} from "./Interfaces";
import Utilities from "./Utilities";
import {IGruppenDB, ISchueler_gruppenDB, ISchuelerDB} from "./InterfacesDB";
import VeraApi from "./VeraApi";
import Veraportal from "./Veraportal";
import Tooltip from './Tooltip';

export default class Gruppenzuordnung extends Veraportal implements IPortalseite {
    override async onSeiteLoad(): Promise<boolean> {
        const gruppenzuordnungDom = document.querySelector(`div#gruppenzuordnung-container`) as HTMLDivElement ?? null;

        if (gruppenzuordnungDom === null)
            return false;

        if (this.gruppenliste.length === 0) {
            gruppenzuordnungDom.innerHTML = `<span>Bisher wurden noch keine Gruppen angelegt.</span>`;
            return false;
        }

        if (this.schuelerliste.length === 0) {
            gruppenzuordnungDom.innerHTML = `<span>Bisher wurden noch keine Schüler angelegt.</span>`;
            return false;
        }

        gruppenzuordnungDom.innerHTML = `
        <div class="schuelerliste">
            <div class="platzhalter"></div>
            <div class="container"></div>
        </div>
        <div class="gruppen">
            <div class="stammklassen">
                <div class="bezeichnung">Stammklassen</div>
                <div class="container"></div>
            </div>
            <div class="kurse">
                <div class="bezeichnung">${this.sessionvariablen.schule.land !== 'ni' ? `Kurse` : `Lerngruppen`}</div>
                <div>
                    <div class="ma">
                        <div class="bezeichnung">Mathematik</div>
                        <div class="container"></div>
                    </div>
                    <div class="de">
                        <div class="bezeichnung">Deutsch</div>
                        <div class="container"></div>
                    </div>
                    <div class="en">
                        <div class="bezeichnung">Englisch</div>
                        <div class="container"></div>
                    </div>
                    <div class="fr">
                        <div class="bezeichnung">Französisch</div>
                        <div class="container"></div>
                    </div>
                </div>
            </div>
        </div>
        `;

        this.refreshGruppenliste();

        //region Sprungmarken für Schüler ansteuern
        let sprungmarkeSchuelerId: number = this.sessionvariablen.get['schuelerid'] ?? null;
        let sprungmarkeSchuelerNr: number = this.sessionvariablen.get['schuelernr'] ?? null;
        let sprungmarkeGruppenbezeichnung: string = this.sessionvariablen.get['gruppenbezeichnung'] ?? null;

        //Zu Schüler springen
        try {
            if (sprungmarkeSchuelerId !== null || sprungmarkeSchuelerNr !== null) {
                let schuelerDom = document.querySelector(`div#gruppenzuordnung-container div.schueler[data-schuelerid='${sprungmarkeSchuelerId}'], div#gruppenzuordnung-container div.schueler[data-nr='${sprungmarkeSchuelerNr}']`);
                schuelerDom.scrollIntoView({block: "center"});
                schuelerDom.classList.add('sprungmarke-highlight');
                setTimeout(() => {
                    schuelerDom.classList.remove('sprungmarke-highlight');
                }, 3000);
            }
            if (sprungmarkeGruppenbezeichnung !== null) {
                let gruppeDom = document.querySelector(`div#gruppenzuordnung-container div.gruppe[data-gruppenbezeichnung='${sprungmarkeGruppenbezeichnung}']`);
                gruppeDom.classList.add('sprungmarke-highlight');
                setTimeout(() => {
                    gruppeDom.classList.remove('sprungmarke-highlight');
                }, 3000);
            }
        } catch (e) {
            Utilities.errorToSentry(e);
        }

        //Parameter aus URL-Bar entfernen
        try {
            let url = new URL(window.location.href);
            let params = new URLSearchParams(url.search);
            params.delete('schuelerid');
            params.delete('itemid');
            params.delete('schuelernr');
            params.delete('gruppenbezeichnung');
            window.history.pushState({}, document.title, '?' + params.toString());
        } catch (e) {
            Utilities.errorToSentry(e);
        }
        //endregion


        return true;
    }

    override async onSeiteFinished(): Promise<boolean> {
        this.pushLoop(); //Timer-Schleife speichert alle refresh_update_msec die Änderungen in der Gruppenliste


        return true;
    }

    override async onSeiteLeave(): Promise<boolean> {
        // Gruppen-Verwaltung speichern, bevor die Seite wechselt
        await this.pushGruppenzuordnungToApi();


        return true;
    }

    public pushGruppenzuordnungToApi(): Promise<boolean> {
        if (document.querySelectorAll(`div#gruppenzuordnung-container`)?.length === 0) return new Promise((resolve) => {
            resolve(false);
        });

        return new Promise(async (resolve) => {
            let changedZuordnungArrDOM: NodeListOf<HTMLElement> = document.querySelectorAll(`div#gruppenzuordnung-container div.auswahl[data-changed='1']`);
            if (changedZuordnungArrDOM.length === 0) {
                resolve(true);
                return;
            }

            let changedZuordnungDeleteArr: ISchueler_gruppenDB[] = [];
            let changedZuordnungInsertArr: ISchueler_gruppenDB[] = [];
            for (let sg = 0; sg < changedZuordnungArrDOM.length; sg++) {
                try {
                    if ((changedZuordnungArrDOM[sg].querySelector(`input`) as HTMLInputElement).checked === false) {
                        changedZuordnungDeleteArr.push({
                            schueler_id: parseInt(changedZuordnungArrDOM[sg].getAttribute('data-schuelerid')),
                            gruppe_id: parseInt(changedZuordnungArrDOM[sg].getAttribute('data-gruppeid'))
                        });
                    } else {
                        changedZuordnungInsertArr.push({
                            schueler_id: parseInt(changedZuordnungArrDOM[sg].getAttribute('data-schuelerid')),
                            gruppe_id: parseInt(changedZuordnungArrDOM[sg].getAttribute('data-gruppeid'))
                        });
                    }

                } catch (e) {
                    Utilities.errorToSentry(e);

                    resolve(false);
                    return;
                }
            }

            try {
                const api = VeraApi.getInstance(this);

                if (changedZuordnungDeleteArr.length !== 0) {
                    let responseDeleteGruppenZuordnung: ISchueler_gruppenDB[] = await api.deleteSchuelerGruppenZuweisungen(changedZuordnungDeleteArr);

                    // Gruppenzuordnungen nach DELETE aktualisieren
                    if (responseDeleteGruppenZuordnung?.length > 0) {
                        for (const deletedZuordnung of responseDeleteGruppenZuordnung) {
                            let index = this.schuelerGruppenZuweisungen
                                ?.findIndex(
                                    e =>
                                        e.schueler_id === deletedZuordnung.schueler_id &&
                                        e.gruppe_id === deletedZuordnung.gruppe_id
                                );
                            if (index !== -1) {
                                this.schuelerGruppenZuweisungen
                                    ?.splice(index, 1);
                            }
                        }
                    }
                }

                let responseInsertGruppenZuordnung: ISchueler_gruppenDB[] = [];
                if (changedZuordnungInsertArr.length !== 0) {
                    responseInsertGruppenZuordnung = await api.postSchuelerGruppenZuweisungen(changedZuordnungInsertArr, true);
                    this.schuelerGruppenZuweisungen = responseInsertGruppenZuordnung; // Gruppenzuordnungen aktualisieren
                }

                // changed-Attribut an Zuordnungen zurücksetzen
                document.querySelector(`div#gruppenzuordnung-container div.auswahl[data-changed='1']`)
                    ?.setAttribute('data-changed', '0');

                // Scrollzustand merken und wiederherstellen
                let scrollTop: number = (document.querySelector(`div#gruppenzuordnung-container div.schuelerliste > div.container`) as HTMLDivElement)?.scrollTop ?? 0;
                this.refreshGruppenliste(scrollTop);

                resolve(true);
            } catch (e) {
                Utilities.errorToSentry(e);

                resolve(false);
            }

        });
    }

    private refreshGruppenliste(scrollTop: number = 0): void {
        if (document.querySelectorAll(`div#gruppenzuordnung-container`)?.length === 0) return;

        // Schülerliste befüllen
        document.querySelector(`div#gruppenzuordnung-container > div.schuelerliste > div.container`).innerHTML =
            this.schuelerliste.filter(s => s.is_deaktiviert === 0)
                .map(this.schuelerHTML).join('');

        // Stammklassen befüllen
        document.querySelector(`div#gruppenzuordnung-container > div.gruppen > div.stammklassen > div.container`).innerHTML =
            this.gruppenliste.filter(g => g.typ === 'STAMMKLASSE')
                .map(this.gruppeHTML).join('');

        // Kurse befüllen
        if (this.gruppenliste.filter(g => ['KURS', 'LERNGRUPPE'].includes(g.typ)).length === 0) {
            document.querySelector(`div#gruppenzuordnung-container > div.gruppen > div.kurse`)?.classList.add('disabled');
        } else {
            for (const fach of ['ma', 'de', 'en', 'fr']) {
                if (this.gruppenliste.filter(g => ['KURS', 'LERNGRUPPE'].includes(g.typ) && g.kurs_fach === fach).length === 0) {
                    document.querySelector(`div#gruppenzuordnung-container > div.gruppen > div.kurse div.${fach}`)?.classList.add('disabled');
                    continue;
                }
                document.querySelector(`div#gruppenzuordnung-container > div.gruppen > div.kurse div.${fach} > div.container`).innerHTML =
                    this.gruppenliste.filter(g => ['KURS', 'LERNGRUPPE'].includes(g.typ) && g.kurs_fach === fach)
                        .map(this.gruppeHTML).join('');
            }
        }

        // Gruppennamen-Platzhalter schrumpfen
        try {
            let gruppennameMaxCharacters: number = Math.max.apply(Math, this.gruppenliste.map(g => g.bezeichnung.length)) ?? null;
            if (gruppennameMaxCharacters !== null && gruppennameMaxCharacters < 18) {
                document.querySelector(`div#gruppenzuordnung-container > div.schuelerliste > div.platzhalter`).setAttribute('style', `height: calc(75px + 30px + ${gruppennameMaxCharacters + 2}ch);`);
                document.querySelectorAll(`div#gruppenzuordnung-container > div.gruppen div.gruppe > div.bezeichnung`).forEach(e => e.setAttribute('style', `height: calc(30px + ${gruppennameMaxCharacters + 2}ch);`));
            }
        } catch {
            //
        }

        this.initUiStyling();

        // Hervorhebung des aktuellen Schülers und der aktuellen Gruppe
        document.querySelectorAll(`div#gruppenzuordnung-container div.auswahl`).forEach(e => {
            e.addEventListener('mouseover', (e) => {
                (e.target as HTMLElement).closest(`div.gruppe`)?.classList.add('highlight');
                let highlightSchuelerId: number = parseInt((e.target as HTMLElement).closest(`div.auswahl[data-schuelerid]`).getAttribute('data-schuelerid')) ?? null;
                document.querySelector(`div.schueler[data-schuelerid='${highlightSchuelerId}']`)?.classList.add('highlight');
            });
            e.addEventListener('mouseleave', (e) => {
                (e.target as HTMLElement).closest(`div.gruppe`)?.classList.remove('highlight');
                let highlightSchuelerId: number = parseInt((e.target as HTMLElement).closest(`div.auswahl[data-schuelerid]`).getAttribute('data-schuelerid')) ?? null;
                document.querySelector(`div.schueler[data-schuelerid='${highlightSchuelerId}']`)?.classList.remove('highlight');
            });
        });

        // Radiobutton-Funktionalität für Checkboxen - Auswahl soll sich gegenseitig ausschließen / Änderungsmarkierung
        document.querySelectorAll(`div#gruppenzuordnung-container div.auswahl input`)
            .forEach((cb: HTMLInputElement) =>
                cb.addEventListener('change', (e) => {
                    try {
                        let auswahlDiv: HTMLElement = (e.target as HTMLElement).closest(`div.auswahl`);
                        let gruppentypDiv: HTMLElement = (e.target as HTMLElement).closest(`div.stammklassen > div.container, div.kurse > div > div > div.container`);
                        let schuelerId = parseInt(auswahlDiv.getAttribute('data-schuelerid'));
                        let gruppeId = parseInt(auswahlDiv.getAttribute('data-gruppeid'));

                        // andere zusammenhängende Checkboxen deaktivieren
                        gruppentypDiv
                            .querySelectorAll(`div.auswahl[data-schuelerid='${schuelerId}']:not([data-gruppeid='${gruppeId}']) input`)
                            .forEach((cb2: HTMLInputElement) => cb2.checked = false);

                        // alle Zusammenhängenden als changed markieren
                        gruppentypDiv.querySelectorAll(`div.auswahl[data-schuelerid='${schuelerId}']`)
                            .forEach(cb => cb.setAttribute('data-changed', '1'));
                    } catch {
                        //
                    }
                })
            );

        // Gruppe bearbeiten-Buttons
        document.querySelectorAll(`button.edit-stammklasse-btn-zuordnungsseite`)
            .forEach(b => b.addEventListener('click', (evt) => {
                    evt.stopPropagation();
                    this.stammklasseEditieren(parseInt($(evt.target).attr('data-gruppeid')) ?? null);
                })
            );
        document.querySelectorAll(`button.edit-kurs-btn-zuordnungsseite`)
            .forEach(b => b.addEventListener('click', (evt) => {
                    evt.stopPropagation();
                    this.kursEditieren(parseInt($(evt.target).attr('data-gruppeid')) ?? null)
                })
            );

        // Klarnamen erneut einfüllen
        if (this.tresor?.offen === true)
            this.tresor.fillTresorLuecken();

        //region Checkbox-Container in Höhe und Scrollfunktionalität initialisieren
        const scrollbareContainer: NodeListOf<HTMLDivElement> = document.querySelectorAll('div#gruppenzuordnung-container div.gruppe > div.container, div#gruppenzuordnung-container div.schuelerliste > div.container');

        // Höhe der Container-Div festsetzen anhand der Bildschirmposition
        function containerHoeheFestlegen() {
            let windowHeight = window.innerHeight;
            let gruppenzuordnungTop = document.querySelector(`div#gruppenzuordnung-container`)?.getBoundingClientRect()?.top ?? null;
            let containerTop = scrollbareContainer[0]?.getBoundingClientRect()?.top ?? null;

            if (gruppenzuordnungTop !== null && containerTop !== null) {
                scrollbareContainer.forEach(c => {
                    c.style.height = `${windowHeight - (containerTop - (gruppenzuordnungTop - 100))}px`;
                });
            }
        }

        containerHoeheFestlegen();
        window.addEventListener('resize', () => {
            containerHoeheFestlegen();
        }, true);

        // Scrollen synchronisieren
        scrollbareContainer.forEach(c => {
            c.addEventListener('scroll', (evt: Event) => {
                const scrollTop: number = (evt.target as HTMLDivElement).scrollTop;
                scrollbareContainer.forEach(c2 => {
                    if (c2 !== evt.target) {
                        c2.scrollTop = scrollTop;
                    }
                    (evt.target as HTMLDivElement).scrollLeft = 0; //Fix: niemals bei Klick horizontal Scrollen
                    // c2.scrollTop = Math.ceil(scrollTop / 30) * 30; TODO:low Scrollen in 30px-Schritten macht Scrollen zu SuS 1 unmöglich
                });
            });
        });
        //endregion

        //region Mouse Grab & Scroll für Schüler-Container
        try {
            const container: HTMLElement = document.querySelector(`div#gruppenzuordnung-container div.schuelerliste > div.container`);
            let isDragging: boolean = false;
            let startY: number, scrollTop: number;

            container.addEventListener('mousedown', (e: MouseEvent): void => {
                isDragging = true;
                startY = e.pageY - container.offsetTop;
                scrollTop = container.scrollTop;
            });

            container.addEventListener('mousemove', (e: MouseEvent): void => {
                if (!isDragging) return;
                e.preventDefault();
                const y = e.pageY - container.offsetTop;
                container.scrollLeft = 0;
                container.scrollTop = scrollTop - (y - startY);
            });

            container.addEventListener('mouseup', (): void => {
                isDragging = false;
            });

            container.addEventListener('mouseleave', (): void => {
                isDragging = false;
            });
        } catch {
            //
        }
        //endregion

        // Scrollzustand wiederherstellen
        if (scrollTop !== 0) {
            try {
                (document.querySelector(`div#gruppenzuordnung-container div.gruppe > div.container`) as HTMLDivElement).scrollTop = scrollTop;
                (document.querySelector(`div#gruppenzuordnung-container div.schuelerliste > div.container`) as HTMLDivElement).scrollTop = scrollTop;
            } catch {
                //
            }
        }

    }

    private schuelerHTML = (
        {schueler_id, nr}: ISchuelerDB
    ): string => {
        return `
        <div class="schueler" data-nr="${nr}" data-schuelerid="${schueler_id}" data-changed="0">
            <div class="nummer">${nr.toString().padStart(3, '0')}</div>
            <div class="klarname">
                <span data-tresor-anzeige="schueler" data-nr="${nr}">Schüler:in ${nr.toString().padStart(3, '0')}</span>
            </div>
        </div>
        `;
    };

    private gruppeHTML = (
        {gruppe_id, bezeichnung, typ, kurs_fach}: IGruppenDB
    ): string => {
        return `
        <div class="gruppe" data-gruppeid="${gruppe_id}" data-gruppenbezeichnung="${bezeichnung}" ${([5, 9].includes(this.sessionvariablen.user.accounttyp)) ? `data-tooltip="${Tooltip.html`
            <p><strong>Zuordnung nicht verfügbar</strong></p>
            <p>Nur die Koordination Ihrer ${this.sessionvariablen.projekt.bezeichnung}-Jahrgangsstufe kann Schülerinnen und Schüler Stammklassen oder Lerngruppen zuordnen.</p>
        `}"` : ``}>
            <div class="bezeichnung">
                <span>
                    ${(this.sessionvariablen.schule.land !== 'ni') ? `
                    <button class="edit-${typ.toLowerCase()}-btn-zuordnungsseite" aria-label="${(typ === 'STAMMKLASSE') ? 'Stammklassen' : 'Kurs'}eigenschaften anpassen" data-tooltip="${Tooltip.html`
                        <p><strong>${(typ === 'STAMMKLASSE') ? 'Stammklassen' : 'Kurs'}eigenschaften anpassen</strong></p>
                    `}" data-gruppeid="${gruppe_id}">
                        <svg role='graphics-symbol'>
                            <use href='/lib/bootstrap-icons/bootstrap-icons/bootstrap-icons.svg#gear-fill'/>
                        </svg>
                    </button>
                    ` : ``}
                    ${bezeichnung.substring(0, 20)}
                </span>
            </div>
            <div class="container">
        ${
            this.schuelerliste.filter(s => s.is_deaktiviert === 0)
                .map(s => {
                    return `
                    <div class="auswahl ${([5, 9].includes(this.sessionvariablen.user.accounttyp)) ? `disabled` : ``}" data-schuelerid="${s.schueler_id}" data-gruppeid="${gruppe_id}" data-changed="0"
                        data-tooltip="${Tooltip.html`
                            <p><strong>Gruppenzuordnung</strong></p>
                            <p>Schüler:in <strong>${s.nr.toString().padStart(3, '0')}</strong> der Gruppe <strong>${bezeichnung}</strong> (${(typ === 'STAMMKLASSE') ? 'Stammklasse' : `${Utilities.printFachLang(kurs_fach)}-Kurs`}) zuordnen.</p>
                        `}"
                    >
                        <input type="checkbox" ${
                        (this.schuelerGruppenZuweisungen
                            .filter(
                                sg =>
                                    sg.schueler_id === s.schueler_id &&
                                    sg.gruppe_id === gruppe_id
                            ).length === 1) ? `checked="checked"` : ``
                    }/>
                    </div>
                    `;
                }).join('')
        }
            </div>
        </div>
        `;
    };


    /**
     * Versucht alle X (this.sessionvariablen.projekt.schuelerinfos_save_msec / 2) Sekunden
     * Gruppenzuordnungen an den Server zu übertragen.
     */
    private pushLoop(): void {
        this.pushGruppenzuordnungToApi()
            .then((result) => {
                // console.log('Push-Versuch');
                // console.log(result);
            })
            .catch((error) => {
                // console.log('Push-Error');
                // console.log(result);
            })
            .finally(() => {
                window.setTimeout(() => {
                    this.pushLoop();
                }, this.sessionvariablen.projekt.schuelerinfos_save_msec / 2);
            });
    }
}
